import { useState } from 'react';
import { LightboxType, getFileTypeFromUrl } from '../utils/filePreview';

export const useLightbox = () => {
  const [lightbox, setLightbox] = useState<{ url: string; type: LightboxType } | null>(null);

  const openLightbox = (url: string, type?: LightboxType) => {
    setLightbox({ url, type: type || getFileTypeFromUrl(url) });
  };

  return { lightbox, setLightbox, openLightbox };
};
